import { AppDispatch } from 'core/store';
import { useDispatch } from 'react-redux';

/**
 * App-specific typesafe alias for `useDispatch`.
 */
export const useAppDispatch: () => AppDispatch = useDispatch;
